import { ITEM_TYPES, ADJUSTMENT_TYPES, PAYMENT_TYPES } from "@/config/constants"

export default {
  data () {
    return {
      isRequestingPayment: false
    }
  },

  methods: {
    findPaymentType(categoryId, vm) {
      let _paymentType = vm.getPaymentTypes
        .find(paymentType => (
          paymentType.category_id === categoryId
        ));

      return _paymentType
        ? _paymentType.id
        : 0
    },

    async addPayment(paymentData, vm) {
      if (!paymentData.paymentTypeId) {
        return
      }

      const modifier_id = this.findPaymentType(paymentData.paymentTypeId, vm);

      if (!modifier_id) {
        vm.errorNotification("Unable to find payment type");
        return;
      }

      const currency = this.$store.getters.getVendor.local_currency;

      const payment = {
        guest_id: vm.selectedTab.guest_id,
        tab_id: vm.selectedTab.id,
        rate: paymentData.amount,
        modifier_id,
        description: paymentData.description
          ? paymentData.description
          : `${ paymentData.paymentMethod } ${ paymentData.paymentType } for ${ vm.selectedGuest }`
      };

      this.isRequestingPayment = true;

      this.$store.dispatch('addPayment', payment)
        .then(tab => {
          vm.selectedTab = tab;
          this.infoNotification(
            `${ currency }${ paymentData.amount } ${ paymentData.paymentType } successfully added to bill for ${ vm.selectedGuest }.`
          );
          this.$store.dispatch('fetchBookings')
        })
        .catch(err => {
          this.errorNotification(`Failed to add payment to  to bill for ${ vm.selectedGuest }.`)
        })
        .finally(() => {
          this.isRequestingPayment = false;
        });
    },

    async addItem(tabItem, vm) {
      const { name } = tabItem;
      delete tabItem.name;

      const itemInfo = vm.availableItems.find(item => item.id === tabItem.item_id);

      if (!itemInfo) {
        vm.errorNotification('unrecognized tab item');
        return;
      }

      this.$store.dispatch('addTabItem', tabItem)
        .then(tab => {
          vm.selectedTab = tab;
          vm.infoNotification(`${ name } added to bill for ${ vm.selectedGuest }`);
        })
        .catch(err => {
          this.errorNotification(`Failed to add ${ name } to bill for ${ vm.selectedGuest }`);
        });
    },

    async addModifier(tabItem, vm) {
      const { name } = tabItem;
      delete tabItem.name;

      tabItem.rate = Math.abs(tabItem.rate);

      const modifierInfo = vm.adjustments
        .find(adjustment => (
          adjustment.id === tabItem.modifier_id
        ));

      if (modifierInfo.category_id === ADJUSTMENT_TYPES.GRATUITY) {
        vm.selectedTab.stats.gratuity += tabItem.rate;

      } else if (modifierInfo.category_id === ADJUSTMENT_TYPES.REFUND) {
        vm.selectedTab.stats.refunded += tabItem.rate;

      } else if (modifierInfo.category_id === ADJUSTMENT_TYPES.DISCOUNT) {
        vm.selectedTab.tab_modifier.push({
          ...tabItem,
          modifier_id: tabItem.modifier_id,
          category_id: modifierInfo.category_id
        });

        vm.selectedTab.stats.discounts += tabItem.rate;

      } else {
        vm.errorNotification('unrecognized adjustment. Could not be added to bill.');
        return;
      }

      if (!tabItem.tab_id) {
        vm.selectedTab.stats.balance_due += parseFloat(tabItem.rate);
        return;
      }

      vm.addTabAdjustment(tabItem)
        .then(tab => {
          vm.selectedTab = tab;
          vm.infoNotification(`${ name } added to bill for ${ vm.selectedGuest }`);
        })
        .catch(err => {
          vm.errorNotification(`Failed to add ${ name } to bill for ${ vm.selectedGuest }`);
        });
    },

    async deleteItemFromTab(tabItem, vm) {
      if (tabItem.category_id === ITEM_TYPES.ACCOMMODATIONS) {
        this.errorNotification(`Cannot remove accomodation via tab.`);
        return;
      }

      return this.$store.dispatch("deleteTabItem", tabItem)
        .then(tab => {
          vm.selectedTab = tab;
          vm.infoNotification(`${ tabItem.name } removed from bill for ${vm.selectedGuest}`);
        })
        .catch(err => {
          this.errorNotification(`Failed to remove ${ tabItem.name } from bill for ${ vm.selectedGuest }`);
        })
    },

    updateTab(tabItemData, vm) {
      const tabItem = {
        ...tabItemData,
        tab_id: vm.selectedTab.id || 0
      }

      if (!!tabItem.item_id) {
        this.addItem(tabItem, vm);
      }

      if (!!tabItem.modifier_id) {
        tabItem.guest_id = vm.selectedTab.guest_id || 0;
        this.addModifier(tabItem, vm)
      }
    }
  }
};
